import React from "react";
import { Store, ArrowRight } from "lucide-react";
import { LLink } from "@/i18n/LLink";
import { useLang } from "@/i18n/LangContext";
import { pageContent, pickLang } from "@/i18n/pageContent";

export const OndernemersCTA = () => {
  const { lang } = useLang();
  const c = pickLang(pageContent.home, lang).cta;
  return (
    <section
      data-testid="home-cta-ondernemers"
      className="ll-section-soft py-16 sm:py-20"
    >
      <div className="ll-container">
        <div className="relative overflow-hidden rounded-3xl bg-[#173A5E] px-6 sm:px-12 py-12 sm:py-16">
          <svg
            className="absolute -bottom-2 left-0 right-0 opacity-20 pointer-events-none"
            viewBox="0 0 1440 200"
            preserveAspectRatio="none"
            aria-hidden="true"
            style={{ height: 160 }}
          >
            <path
              d="M0,120 C240,180 480,60 720,100 C960,140 1200,160 1440,90 L1440,200 L0,200 Z"
              fill="#6BC0E8"
            />
            <path
              d="M0,150 C240,200 480,110 720,140 C960,170 1200,190 1440,140 L1440,200 L0,200 Z"
              fill="#2E9CD6"
              opacity="0.6"
            />
          </svg>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F3C300] text-[#173A5E] font-[Poppins] font-semibold text-xs uppercase tracking-wider mb-5">
                <Store className="w-3.5 h-3.5" />
                {c.badge}
              </div>
              <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-4">
                {c.title1}
                <br />
                {c.title2}
              </h2>
              <p className="text-[#C7D8E6] font-[Inter] text-base sm:text-lg leading-relaxed max-w-lg">
                {c.body}
              </p>
            </div>
            <div className="flex lg:justify-end">
              <LLink
                to="/voor-ondernemers/aanmelden"
                data-testid="cta-ondernemers-btn"
                className="inline-flex items-center gap-2 bg-[#F3C300] hover:bg-[#e0b400] text-[#173A5E] font-[Poppins] font-bold text-base sm:text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all"
              >
                {c.button}
                <ArrowRight className="w-5 h-5" />
              </LLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OndernemersCTA;
